import { isNumber } from "./Validators";

export const displayPhoneFormatter = (number: any) => {
  if (number == null || number == "") {
    return "";
  }
  return number.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
};

export const inputPhoneFormatter = (value: any, previousValue: any) => {
  // return nothing if no value
  if (!value) return value;

  // only allows 0-9 inputs
  const currentValue = value?.replace(/[^\d]/g, "");
  const cvLength = currentValue?.length;

  if (!previousValue || value?.length > previousValue?.length) {
    // returns: "x", "xx", "xxx"
    if (cvLength < 4) return currentValue;

    // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
    if (cvLength < 7)
      return `(${currentValue?.slice(0, 3)}) ${currentValue?.slice(3)}`;

    // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
    return `(${currentValue?.slice(0, 3)}) ${currentValue?.slice(
      3,
      6
    )}-${currentValue?.slice(6, 10)}`;
  } else {
    return value;
  }
};

export const currencyFormatter = (value: any, haveDisplayValue?: boolean, integer?: boolean) => {
  if (value == null || value === "") {
    return "$0";
  }
  if(haveDisplayValue){
    return value; // Patch for displaying provided text
  }

  if (value < 0) {
    return (
      "-$" +
      parseFloat(value * -1 + "")
        .toFixed(integer ? 0 : 2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );
  } else {
    return (
      "$" +
      parseFloat(value)
        .toFixed(integer ? 0 : 2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );
  }
};

export const dateFormatter = (value: any, format = "MM/DD/YYYY") => {
  if (value == null || value === "") {
    return "-";
  }
  let date = new Date(value);
  if (date === null) {
    return "-";
  }
  let year = date.getFullYear();
  let month: string | number = date.getMonth() + 1;
  let day: string | number = date.getDate();

  if (day < 10) {
    day = "0" + day;
  }
  if (month < 10) {
    month = "0" + month;
  }
  if (format == "MM/DD/YYYY") {
    return month + "/" + day + "/" + year;
  } else {
    return year + "" + month + "" + day;
  }
};

export const removeExtraSpace = (s: any) => {
  return s.trim().split(/ +/).join("");
};

export const formatAddress = (address: any) => {
  if (address == null || address === "") {
    return "";
  }
  let address1 =
    address.address1 == null || address.address1 == ``
      ? ``
      : `${address.address1}`;
  let address2 =
    address.address2 == null || address.address2 == ``
      ? ``
      : `${address.address2}`;
  if (address2 !== `` && address1 !== ``) {
    address1 = `${address1} `;
    address2 = `${address2}, `;
  } else if (address2 === `` && address1 !== ``) {
    address1 = `${address1}, `;
  } else if (address2 !== ``) {
    address2 = `${address2}, `;
  }
  let city = address.city == null ? `` : `${address.city}, `;
  let state = address.state == null ? `` : `${address.state} `;
  let zip = address.zip == null ? `` : `${address.zip}`;

  return `${address1}${address2}${city}${state}${zip}`;
};
//Format mailing address from the mailing address object
export const formattedMailingAddress = (mailingAddress: any) => {
  if (mailingAddress == null || mailingAddress === "") {
    return "";
  }
  let ma_careOf =
    mailingAddress.careOf == null || mailingAddress.careOf == ``
      ? ``
      : `${mailingAddress.careOf} `;
  return `${ma_careOf}${formatAddress(mailingAddress)}`;
};

// Get file name from
export const documentNameFormatter = (url: any) => {
  if (!url) {
    return "";
  }
  const components = url.trim().split("-");
  let docName = "";
  for (let value of components) {
    if (isNumber(value)) {
      break;
    } else {
      docName += value + " ";
    }
  }
  if (docName.trim() == "") {
    return url;
  } else {
    return docName.trim();
  }
};

export const formattedValue = (item: any) => {
  if (item == null || item == undefined) {
    return "-";
  }
  const value = item?.displayValue || item?.amount || item.value;
  if (
    item?.type?.toLowerCase() === "integer" &&
    item?.format?.toLowerCase() === "currency"
  ) {
    
    return currencyFormatter(value, !!item?.displayValue, true);
  } else if (
    item?.type?.toLowerCase() === "decimal" ||
    item?.format?.toLowerCase() === "currency"
  ) {
    return currencyFormatter(value, !!item?.displayValue);
  } else if (
    item?.type?.toLowerCase() === "date" ||
    item?.format?.toLowerCase() === "date"
  ) {
    return dateFormatter(value);
  } else if (
    item?.type?.toLowerCase() === "number" ||
    item?.format?.toLowerCase() === "percentage"
  ) {
    return item?.displayValue || (item?.value ? `${item?.value}%` : "");
  } else if (
    item?.type?.toLowerCase() === "boolean" ||
    item?.format?.toLowerCase() === "boolean"
  ) {
    return item?.value ? "Yes" : "No";
  } else {
    return item?.displayValue || item?.value?.toString();
  }
};

export const getFormattedAddressLabel = (address: any) => {
  if (!address) return "";
  const { address1, address2, city, state, zip } = address;
  let parts: string[] = [];
  if (address1) parts.push(address1);
  if (address2) parts.push(address2);
  let locationParts: string[] = [];
  if (city) locationParts.push(city);
  if (state) locationParts.push(state);
  if (zip) locationParts.push(zip);
  if (locationParts.length) parts.push(locationParts.join(", "));
  return parts.join(", ");
};

export const getFormattedLabelText = (label: string) => {
  if (!label) return "";
  return label?.charAt(0).toUpperCase() + label?.slice(1).toLowerCase();
};
